(function () {
  'use strict';

  angular.module('ringbaPortal').component('wizardProgressbar', {
    bindings: {
      wizardStep: '<',
      progressStepTranslationPrefix: '@'
    },
    controller: WizardProgressbarController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/wizard-progressbar/wizard-progressbar.view.html'
  });

  function WizardProgressbarController() {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;

    function onInit() {
      vm.progressStepTranslationPrefix = vm.progressStepTranslationPrefix || 'CAMPAIGN_WIZARD_STEP_PROGRESS';
    }
  }
})();
